type OverlayDismissHandler = () => void;

const dismissHandlers = new Map<string, OverlayDismissHandler>();

/**
 * Регистрирует request-dismiss обработчик для конкретной overlay-surface.
 * @param overlayId идентификатор surface из runtime overlay
 * @param handler обработчик закрытия: может показать confirm, сделать internal cleanup и т.п.
 * @returns функцию снятия регистрации
 */
export function registerOverlayDismissHandler(overlayId: string, handler: OverlayDismissHandler): () => void {
    dismissHandlers.set(overlayId, handler);

    return () => {
        if (dismissHandlers.get(overlayId) === handler) {
            dismissHandlers.delete(overlayId);
        }
    };
}

/**
 * Запрашивает dismiss overlay через зарегистрированный handler.
 * @param overlayId идентификатор surface
 * @returns `true`, если handler найден и вызван
 */
export function requestOverlayDismiss(overlayId: string): boolean {
    const handler = dismissHandlers.get(overlayId);

    if (handler == null) {
        return false;
    }

    handler();
    return true;
}

/**
 * Удаляет dismiss handler без вызова, когда surface закрывается внешним способом.
 * @param overlayId идентификатор surface
 */
export function unregisterOverlayDismissHandler(overlayId: string): void {
    dismissHandlers.delete(overlayId);
}
